import { render, staticRenderFns } from "./AtrasosJustificadosPage.vue?vue&type=template&id=74f5fb14"
import script from "./AtrasosJustificadosPage.vue?vue&type=script&lang=js"
export * from "./AtrasosJustificadosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports